module.exports = __webpack_public_path__ + "media/components/country-flag/static/id-6556f6e15d373e7b550fcfacf6871560.svg";